var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-bg center-position setup-2fa"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('two-step-auth',{on:{"done":_vm.onDone}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }